import React from 'react';
import { Button } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

const RecordsHeader = ({ disabled, showAddForm, setShowAddForm }) => {
  return (
    <div className="employee-balance-header" style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      marginBottom: '16px'
    }}>
      <h4 style={{ margin: 0, color: '#1890ff', fontSize: '16px', fontWeight: '600' }}>
        Monthly Leaves Balance Records
      </h4>
      {!disabled && (
        <Button
          type={showAddForm ? "default" : "primary"}
          icon={showAddForm ? <CloseOutlined /> : <PlusOutlined />}
          onClick={() => setShowAddForm(!showAddForm)}
          size="small"
        >
          {showAddForm ? "Cancel" : "Add New Balance Record"}
        </Button>
      )}
    </div>
  );
};

export default RecordsHeader; 